import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!sessionStorage.getItem("jwtToken"),
  );

  const login = (token, user) => {
    sessionStorage.setItem("jwtToken", token);
    if (user?.id) sessionStorage.setItem("userId", user.id);

    setIsLoggedIn(true);
  };

  const logout = (isSessionExpired = false) => {
    sessionStorage.clear();

    setIsLoggedIn(false);

    if (isSessionExpired) {
      window.location.href = "/session-timeout";
    } else {
      window.location.href = "/";
    }
  };

  // {"\u1F525"} JWT expiry check
  const isTokenExpired = (token) => {
    try {
      if (!token) return true;

      const payload = JSON.parse(atob(token.split(".")[1]));

      return payload.exp * 1000 < Date.now();
    } catch (e) {
      return true;
    }
  };

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const token = sessionStorage.getItem("jwtToken");

      // token expired before API call
      if (token && isTokenExpired(token)) {
        logout(true);
        return Promise.reject("Session expired");
      }

      const response = await originalFetch(...args);

      // backend unauthorized
      if (response.status === 401 || response.status === 403) {
        logout(true);
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
